import React, { useGlobal, useEffect, useState } from 'reactn';
import { ManageDeliveryStyled } from './ManageDelivery.styled';
import DropDownButton from '../DropDownButton';
import DeliveryHistoryTimeline from '../deliveryHistoryTimeline';
import DeliveryItemOverview from '../deliveryItemOverview';
import { getAutoDib, getDeliveryManager, getTrackingHistory } from '../../../services/Api';
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";
import Icon from '../../_common/icons/ReturnIcons';
import profileHooks from '../../../hooks/profileHooks';
import CustomsChargesView from '../customsChargesOverview';
import ErrorMessage from '../errorMessage';
import { pushDataLayer } from '../../../helpers/Helpers';
import ReceivedItemsInfoBanner from '../receivedItemsInfoBanner';
import deliveryHooks from '../../../hooks/deliveryHooks';

const ManageDelivery = () => {
    const [selectedTrackingItem, setSelectedTrackingItem] = useGlobal("selectedTrackingItem");
    const [originalDeliveryAddress, setOriginalDeliveryAddress] = useGlobal("originalDeliveryAddress");
    const [trackingItems, setTrackingItems] = useGlobal("trackingItems");
    const [autoDib, setAutoDib] = useState(null);
    const [deliveryManagerGet, setDeliveryManagerGet] = useState();
    const [showDropDown, setShowDropDown] = useState(false);
    const [showBanner, setShowBanner] = useState(false);
    const { values } = profileHooks();
    const { isMobile } = DetectDeviceResize();
    const [newTrackingItems, setNewTrackingItems] = useState();
    const [apiError, setApiError] = useState(false);
    const [refetch, setRefetch] = useGlobal('refetch');
    const [mappedResults, setMappedResults] = useState([]);
    const [indexMapping] = useGlobal("manageDeliveriesDropdownButtonIndexMapping");
    const { getManageDeliveriesDropdownOptions } = deliveryHooks();

    useEffect(() => {
        let isMounted = true;

        getAutoDib(values.ciamUserId).then((res) => {
            if (isMounted) {
                setAutoDib(res.data.autoDIB.filter(item => item.emailAddress));
            }
        });

        return () => {
            isMounted = false;
        };
    }, [values.ciamUserId, refetch]);


    useEffect(() => {
        if (selectedTrackingItem) {
            getTrackingHistory(values.ciamUserId).then((trackingData) => {
                const trackingItem = trackingData.data.trackingItems.find(item => item.trackingNumber === selectedTrackingItem.trackingNumber);
                setNewTrackingItems(trackingItem)
                setTrackingItems(trackingData.data.trackingItems);
                // setSelectedTrackingItem(trackingItem);
                if (!trackingItem.deliveryManagerAvailable && !trackingItem.deliveryManagerInstructionDetail && !trackingItem.deliveryManagerInstructionSet
                ) {
                    setOriginalDeliveryAddress("")
                    setDeliveryManagerGet(null)
                    return
                }

                if (trackingItem && trackingItem.deliveryManagerAvailable) {
                    setShowDropDown(true)
                }

                getDeliveryManager(values.ciamUserId, [trackingItem.trackingNumber]).then((res) => {
                  if(res.data.statuses[0].originalDeliveryAddress) {
                      setOriginalDeliveryAddress(res.data.statuses[0].originalDeliveryAddress);
                  }

                  setDeliveryManagerGet(res.data.statuses[0]);
                  if(res.data.statuses[0].availableServices) {
                      return res.data.statuses[0].availableServices;
                  }
                  return
                }).then((res) => {
                  if (res) {
                    if (res.includes("Y")) {
                      const newMappedResults = getManageDeliveriesDropdownOptions(indexMapping, res);
                      
                      setMappedResults(newMappedResults);
                    } else {
                      setShowDropDown(false);
                    }
                  }
                }).catch(() => {
                    setApiError(true);
                });
            })

            if (selectedTrackingItem !== null) {
              if (selectedTrackingItem.lastTrackingEventCategoryId === "7") {
                getTrackingHistory(values.ciamUserId, selectedTrackingItem.trackingNumber).then((res) => {
                  const trackingItemHistoriesArray = res.data.trackingItemHistories;
                  const allWebCategoryIdIs7 = trackingItemHistoriesArray.every(item => item.webCategoryId === "7");

                  if (allWebCategoryIdIs7) {
                    const dateString = trackingItemHistoriesArray[0].date;

                    // Convert string to date object
                    const dateObject = new Date(dateString);

                    // Get the current date and time
                    const currentDate = new Date();

                    // Check if the date is more than 24 hours ago
                    const timeDifference = currentDate - dateObject;
                    const isMoreThan24HoursAgo = timeDifference > (24 * 60 * 60 * 1000);

                    if (isMoreThan24HoursAgo) {
                      setShowBanner(true);
                    }
                  } else {
                    setShowBanner(false);    
                  }
                });
              } else {
                setShowBanner(false);
              }
            }
        }

        return () => setShowDropDown(false);
    }, [selectedTrackingItem, autoDib, refetch]);

    const customChargesClick = () => {
        if (selectedTrackingItem.lastTrackingEventCategoryId === "1" && selectedTrackingItem.customsPaymentRequired) {
         
            window.location.href = `${window.location.origin}/Post-Parcels/Receiving/Pay-Customs-Charge?revenueNumber=${selectedTrackingItem.mrn}&trackingNumber=${selectedTrackingItem.trackingNumber}`;
        }
    }

    useEffect(() => {
        if (selectedTrackingItem && selectedTrackingItem.lastTrackingEventCategoryId === "1" && selectedTrackingItem.customsPaymentRequired) {
            pushDataLayer({
                event: "customsToBeActioned",
            })
        }
    }, [selectedTrackingItem])

    return (
        <ManageDeliveryStyled exist={selectedTrackingItem !== null} apiError={apiError}>
            {apiError ? <ErrorMessage message={"We're sorry but we can't retrieve your delivery information right now."}
            tryAgainEvent={() => window.location.reload()}
            /> : <>
                {isMobile && <span onClick={() => setSelectedTrackingItem(null)} className='mobileBackWrapper'> <Icon src='leftArrowIcon' />Back</span>}
                {selectedTrackingItem && <>
                    {selectedTrackingItem.lastTrackingEventCategoryId === "1" && selectedTrackingItem.customsPaymentRequired && <CustomsChargesView customsRedirectHandler={customChargesClick} />}
                    
                    {showBanner && (
                      <ReceivedItemsInfoBanner />
                    )}

                    {showDropDown && (
                      <DropDownButton
                        dropDownItems={mappedResults}
                        deliveryManagerResults={deliveryManagerGet}
                      />
                    )}

                    <DeliveryHistoryTimeline trackingItem={selectedTrackingItem} />
                    <DeliveryItemOverview trackingItem={newTrackingItems} deliveryManagerGet={deliveryManagerGet} autoDib={autoDib} />
                    <span className='textNotes'>
                        <b>Note:</b> This information is only for confirming delivery of parcels delivered by An Post. It is an offence under Section 53 of the Communications Regulation (Postal Services) Act 2011 to use information obtained from a postal parcel for any other purpose.
                    </span>
                </>}
            </>}
        </ManageDeliveryStyled>
    );
};

export default ManageDelivery;
